import React from 'react'
import { Link } from 'react-router-dom'
import { FaArrowRight } from "react-icons/fa";
import HighlightText from '../components/core/HomePage/HighlightText';
import CTAButton from '../components/core/HomePage/Button'
import Banner from '../assets/images/banner.mp4'
import CodeBlocks from '../components/core/HomePage/CodeBlocks';
import LearningLanguageSection from '../components/core/HomePage/LearningLanguageSection';
import TimelineSection from '../components/core/HomePage/TimelineSection';
import InstructorSection from '../components/core/HomePage/InstructorSection';
import Footer from '../components/common/Footer';
import ExploreMore from '../components/core/HomePage/ExploreMore';
import ReviewSlider from '../components/common/ReviewSlider';
import { useSelector } from 'react-redux';


const Home = () => {

  const{token} = useSelector((state)=>state.auth)
  return (
    <div>

        {/* Section 1 */}
        <div className='relative mx-auto flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8 text-white'>
          
           {/* Become a Instructor Button */}
            <Link  to='/signup'>
            <div className="group mx-auto mt-16 w-fit rounded-full bg-richblack-800 p-1 font-bold text-richblack-50 drop-shadow-[0_1.5px_rgba(255,255,255,0.25)] transition-all duration-200 hover:scale-95 hover:drop-shadow-none">
             <div className="flex flex-row items-center gap-2 rounded-full px-10 py-[5px] transition-all duration-200 group-hover:bg-richblack-900">
                    <p>
                      {
                        token !==null ? <div>Go to Your DashBoard</div> : <div>Create Account or Login</div>
                      }
                    </p>
                    <FaArrowRight />
                </div>
              </div>
            </Link>
            
             {/* Heading */}
            <div className='text-center text-4xl font-semibold'> 
              Empower Your Future with 
              <HighlightText text={" Coding Skills"}/>
            </div>
            
            {/* Subheading */}
            <div className='-mt-3 w-[90%] text-center text-lg font-bold text-richblack-300'>
             With our online coding courses, you can learn at your own pace, from anywhere in the world, and get access to a wealth of resources, including hands-on projects, quizzes, and personalized feedback from instructors. 
            </div>
             
             {/* CTA Button */}
            <div className='mt-8 flex flex-row gap-7'>
              <CTAButton active={true} linkto={'/signup'}>
                Learn more
              </CTAButton>
              <CTAButton active={false} linkto={'/login'}>
                Book a Demo
              </CTAButton>
            </div>
            
            {/* Video */}
            <div className= 'mx-3 my-7 shadow-[10px_-5px_50px_-5px] shadow-blue-200'>
              <video muted loop autoPlay  className='shadow-[20px_20px_rgba(255,255,255)]'>
                <source src={Banner} type='video/mp4' />
              </video>
            </div>

            {/* Code section 1*/}
            <div>
              <CodeBlocks 
              position={'lg:flex-row'}
              heading={
                <div className='text-4xl font-semibold'>
                  Unlock Your 
                  <HighlightText text={' Coding Potential '}/>
                  with our online courses     
                </div>            
              }
              subHeading={
                 "Our courses are designed and taught by industry experts who have years of experience in coding and are passionate about sharing their knowledge with you."
              }

              ctabtn1={
                {
                  btnText:"Try it Yourself",
                  linkto:'/signup',
                  active:true
                }
              }

              ctabtn2={
                {
                  btnText:"Learn More",
                  linkto:'/login',
                  active:false
                }
              }

              codeblock={`<!DOCTYPE html>\n <html lang="en">\n<head>\n<title>This is myPage</title>\n</head>\n<body>\n<h1><a href="/">Header</a></h1>\n<nav> <a href="/one">One</a> <a href="/two">Two</a> <a href="/three">Three</a>\n</nav>\n</body>`}
              codeColor={'text-yellow-25'}
              backgroundGradient={<div className="codeblock1 absolute"></div>}
              />
            </div>

            {/* Code section 2 */}
            <div>
              <CodeBlocks 
              position={'lg:flex-row-reverse'}
              heading={
                <div className='text-4xl font-semibold'>
                   Start
                  <HighlightText text={' Coding in Seconds '}/>    
                </div>            
              }
              subHeading={
                 "Go ahead, give it a try. Our hands-on learning environment means you'll be writing real code from your very first lesson."
              }

              ctabtn1={
                {
                  btnText:"Continue Lesson",
                  linkto:'/signup',
                  active:true
                }
              }

              ctabtn2={
                {
                  btnText:"Learn More",
                  linkto:'/login',
                  active:false
                }
              }

              codeblock={`<!DOCTYPE html>\n <html lang="en">\n<head>\n<title>This is myPage</title>\n</head>\n<body>\n<h1><a href="/">Header</a></h1>\n<nav> <a href="/one">One</a> <a href="/two">Two</a> <a href="/three">Three</a>\n</nav>\n</body>`}
              codeColor={'text-yellow-25'}
              backgroundGradient={<div className="codeblock2 absolute"></div>}            
              />
            </div>

            <ExploreMore/>
            
        </div>


        {/* Section 2 */}

        <div className='bg-pure-greys-5 text-richblack-700'>

          <div className='homepage_bg h-[320px]'>
             {/* Explore Full Catagory Section */}
            <div className='w-11/12 max-w-maxContent mx-auto flex flex-col items-center gap-8 justify-center '>
              <div className='lg:h-[150px]'></div>
              <div className='flex flex-row gap-7 text-white lg:mt-8'>
                 <CTAButton active={true} linkto={'/signup'}>
                   <div className='flex gap-3 items-center'>
                    Explore Full Catelog
                    <FaArrowRight/>
                   </div>
                 </CTAButton>

                 <CTAButton active={false} linkto={'/signup'}>
                   Learn More              
                 </CTAButton>
              </div>
            
            </div>  

          </div>

          <div className='w-11/12 max-w-maxContent mx-auto flex flex-col items-center justify-between gap-7'>
            {/* Job that is in Demand - Section 1 */}
            <div className='flex flex-col lg:flex-row gap-7 lg:gap-0  mb-10 -mt-[100px] lg:mt-20 justify-between'>

              <div className='text-4xl font-semibold lg:w-[45%]'>
                Get the skills you need for a 
                <HighlightText text={' job that is in demand.'}/>     
              </div>

              <div className='flex flex-col items-start gap-10 lg:w-[40%]'>
                <div>
                  The modern StudyNotion is the dictates its own terms. Today, to be a competitive specialist requires more than professional skills.
                </div>
                <CTAButton active={true}>Learn More</CTAButton>             
              </div>

            </div>

            <TimelineSection/>

            <LearningLanguageSection/>

          </div>        
        </div>

        

        {/* Section 3 */}
        <div className='w-11/12 mx-auto max-w-maxContent flex-col items-center justify-between gap-8 first-letter bg-richblack-900 text-white'>
          
          <InstructorSection/>

          <h2 className='text-4xl text-center font-semibold mt-10'>Reviews from other learners</h2>

          {/* Reviews slider */}
          <ReviewSlider/>

        </div>

        {/* Footer */}

        <Footer/>

    </div>
  )
}

export default Home